import { httpClient } from "../httpClient";

/**
 * GET /admin/contact-messages
 */
export function listContactMessages(params = {}) {
  return httpClient.get("/admin/contact-messages", { params });
}

export function getContactMessage(id) {
  return httpClient.get(`/admin/contact-messages/${encodeURIComponent(id)}`);
}

export function patchContactMessage(id, body) {
  return httpClient.patch(
    `/admin/contact-messages/${encodeURIComponent(id)}`,
    body
  );
}

export function deleteContactMessage(id) {
  return httpClient.delete(
    `/admin/contact-messages/${encodeURIComponent(id)}`
  );
}

export function postContactMessageReply(id, body) {
  return httpClient.post(
    `/admin/contact-messages/${encodeURIComponent(id)}/replies`,
    body
  );
}

/**
 * POST /admin/contact-messages/:id/emails
 * @param {{ subject: string, body: string }} body
 */
export function postContactMessageEmail(id, body) {
  return httpClient.post(
    `/admin/contact-messages/${encodeURIComponent(id)}/emails`,
    body
  );
}

/**
 * POST /admin/contact-messages/:parentId/emails/:emailMessageId/analysis/run
 * @param {string} parentId
 * @param {string} emailMessageId
 * @param {{ instructionNote?: string, locale?: string }} [body]
 */
export function postContactMessageEmailAnalysisRun(parentId, emailMessageId, body = {}) {
  return httpClient.post(
    `/admin/contact-messages/${encodeURIComponent(parentId)}/emails/${encodeURIComponent(emailMessageId)}/analysis/run`,
    body
  );
}

export function postContactMessageNote(id, body) {
  return httpClient.post(
    `/admin/contact-messages/${encodeURIComponent(id)}/notes`,
    body
  );
}

export function deleteContactMessageNote(id, noteId) {
  return httpClient.delete(
    `/admin/contact-messages/${encodeURIComponent(id)}/notes/${encodeURIComponent(noteId)}`
  );
}

export function publicCreateContactMessage(body) {
  return httpClient.post("/public/contact-messages", body, { skipAuth: true });
}
